const AgreeList = {
	group: '用户协议',
	list: [
		{
			id: 1,
			title: '用户协议',
			goto: { path: '/info', query: { group: '用户协议', id: 1, type: 'content', title: '用户协议' } },
			class: 'is-open',
			content:
				'注册协议-在您使用特规通账号的注册和使用服务（如下简称“本服务”）之前，我们在此特别提醒您，请您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制特规通责任的条款，对您的权利限制条款，争议解决和法律适用条款等，此类条款将以加粗的形式提示您注意。您通过网络页面点击同意和/或注册和使用特规通账号的行为，即视为您已阅读、理解并同意接受本协议，并同意接受本协议各项条款的约束。若您不同意本协议，则您有充分且完全的权利退出本服务。'
		},
		{
			id: 2,
			title: '隐私协议',
			goto: { path: '/info', query: { group: '用户协议', id: 2, type: 'content', title: '隐私协议' } },
			class: '',
			content:
				'隐私协议-在您使用特规通账号的注册和使用服务（如下简称“本服务”）之前，我们在此特别提醒您，请您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制特规通责任的条款，对您的权利限制条款，争议解决和法律适用条款等，此类条款将以加粗的形式提示您注意。您通过网络页面点击同意和/或注册和使用特规通账号的行为，即视为您已阅读、理解并同意接受本协议，并同意接受本协议各项条款的约束。若您不同意本协议，则您有充分且完全的权利退出本服务。'
		},
		{
			id: 3,
			title: '图书销售协议',
			goto: { path: '/info', query: { group: '用户协议', id: 3, type: 'content', title: '图书销售协议' } },
			class: '',
			content:
				'图书销售协议-在您使用特规通账号的注册和使用服务（如下简称“本服务”）之前，我们在此特别提醒您，请您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制特规通责任的条款，对您的权利限制条款，争议解决和法律适用条款等，此类条款将以加粗的形式提示您注意。您通过网络页面点击同意和/或注册和使用特规通账号的行为，即视为您已阅读、理解并同意接受本协议，并同意接受本协议各项条款的约束。若您不同意本协议，则您有充分且完全的权利退出本服务。'
		},
		// {
		// 	id: 3,
		// 	title: '社区规则',
		// 	goto: { path: '/info', query: { group: '用户协议', id: 3, type: 'content', title: '社区规则' } },
		// 	class: '',
		// 	content:
		// 		'社区规则-在您使用特规通账号的注册和使用服务（如下简称“本服务”）之前，我们在此特别提醒您，请您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制特规通责任的条款，对您的权利限制条款，争议解决和法律适用条款等，此类条款将以加粗的形式提示您注意。您通过网络页面点击同意和/或注册和使用特规通账号的行为，即视为您已阅读、理解并同意接受本协议，并同意接受本协议各项条款的约束。若您不同意本协议，则您有充分且完全的权利退出本服务。'
		// }
		// {
		// 	id: 4,
		// 	title: '商家入驻协议',
		// 	goto: { path: '/info', query: { group: '用户协议', id: 4, type: 'content', title: '商家入驻协议' } },
		// 	class: '',
		// 	content:
		// 		'商家入驻协议-在您使用特规通账号的注册和使用服务（如下简称“本服务”）之前，我们在此特别提醒您，请您认真阅读、充分理解本协议各条款，特别是涉及服务费用条款，免除或者限制特规通责任的条款，对您的权利限制条款，争议解决和法律适用条款等，此类条款将以加粗的形式提示您注意。您通过网络页面点击同意和/或注册和使用特规通账号的行为，即视为您已阅读、理解并同意接受本协议，并同意接受本协议各项条款的约束。若您不同意本协议，则您有充分且完全的权利退出本服务。'
		// }
	]
};

export default AgreeList;
